import { FaExclamationTriangle } from 'react-icons/fa';
import Dialog from '../../organisms/Dialog';
import { DuplicateRow } from './duplicateRows';

interface Props {
    show: boolean;
    rows: DuplicateRow[];
    onDecision: (proceed: boolean) => void;
}

const formatDate = (iso: string): string => iso.split('-').reverse().join('/');

const DuplicateIssuanceModal = ({ show, rows, onDecision }: Props) => (
    <Dialog
        id="duplicate-issuance"
        show={show}
        onClose={() => onDecision(false)}
        size="lg"
        header="Possível emissão duplicada"
        body={
            <div className="p-4">
                <div className="flex items-center gap-2 text-sm text-amber-700 dark:text-amber-400 mb-3">
                    <FaExclamationTriangle className="shrink-0" />
                    <span>
                        {rows.length === 1 ? '1 linha parece' : `${rows.length} linhas parecem`} duplicada
                        {rows.length === 1 ? '' : 's'}: mesma casa, produto, taxa, datas, quantidade e preços de uma boleta já enviada.
                        Confira antes de seguir.
                    </span>
                </div>
                <div className="overflow-x-auto border border-gray-200 dark:border-slate-700 rounded-lg">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-left text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-slate-800">
                                <th className="py-2 px-3 font-medium">Linha</th>
                                <th className="py-2 px-3 font-medium">Produto</th>
                                <th className="py-2 px-3 font-medium text-right">Quantidade</th>
                                <th className="py-2 px-3 font-medium">Vencimento</th>
                                <th className="py-2 px-3 font-medium">Motivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row) => (
                                <tr key={row.line} className="border-t border-gray-100 dark:border-slate-700 bg-amber-50 dark:bg-amber-900/20">
                                    <td className="py-2 px-3">{row.line}</td>
                                    <td className="py-2 px-3">{row.product}</td>
                                    <td className="py-2 px-3 text-right [font-variant-numeric:tabular-nums]">{row.quantity}</td>
                                    <td className="py-2 px-3">{formatDate(row.dueDate)}</td>
                                    <td className="py-2 px-3">
                                        {row.reasons.map((reason, index) => (
                                            <div key={`${row.line}-${index}`}>{reason}</div>
                                        ))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        }
        footer={
            <div className="flex gap-3">
                <button
                    type="button"
                    onClick={() => onDecision(false)}
                    className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-slate-700 hover:bg-gray-200 dark:hover:bg-slate-600 rounded-lg transition-colors"
                >
                    Voltar
                </button>
                <button
                    type="button"
                    onClick={() => onDecision(true)}
                    className="px-4 py-2 text-sm text-white bg-amber-500 hover:bg-amber-600 rounded-lg transition-colors"
                >
                    Seguir mesmo assim
                </button>
            </div>
        }
    />
);

export default DuplicateIssuanceModal;
